import { QuestionInfo } from "../common/question-info";

export class EligibilityQuestionsResult {
  public SalesId: string;
  public EligibilityQuestions: QuestionInfo[];
}
